import { useMainBorrowerPricingState } from "../../contexts/main-borrower-pricing/MainBorrowerPricingContext"
import { useFilteredContractFunnels } from "../../contexts/main-borrower-pricing/selectors/selectors"
import { FunnelCardSkeletonList } from "features/subscription-process/pricing-process/components/loading/FunnelCardSkeleton"
import { BorrowerFunnelCard } from "./BorrowerFunnelCard"

export const BorrowerPricingFunnels = () => {
  const { isProMode, isContractFunnelsLoading } = useMainBorrowerPricingState()
  const filteredContractFunnels = useFilteredContractFunnels()

  return <div className="flex flex-col ml-4 gap-4 w-full">
    <p className="text-2xl font-bold">Résultats de recherche</p>
    {isContractFunnelsLoading && (
      <FunnelCardSkeletonList count={3} showProMode={isProMode} />
    )}
    {!isContractFunnelsLoading && filteredContractFunnels.map((contractFunnel, index) => (
      <BorrowerFunnelCard
        key={contractFunnel.hash || index}
        isProMode={isProMode}
        contractFunnel={contractFunnel}
      />
    ))}
    {!isContractFunnelsLoading && filteredContractFunnels.length === 0 && (
      <div className="flex flex-col items-center justify-center py-16 px-4 border bg-gray-50 rounded-xl">
        <div className="bg-gray-50 rounded-full p-6 mb-4">
          <svg
            className="w-16 h-16 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Aucun tunnel trouvé
        </h3>
        <p className="text-gray-500 text-center max-w-md">
          Aucun résultat ne correspond à vos critères de recherche.
          Essayez de modifier vos filtres ou paramètres.
        </p>
      </div>
    )}
  </div>
}
